import React, { useContext, useRef } from "react";
import { CustomText, Input, InputDate } from "../../components";
import { FormFull } from "form-full";
import { fonts } from "../../config";

import { alerts, hooks, masks, validations } from "../../utils";

import { CircularProgress, Grid } from "@material-ui/core";
import { HomeWork, Visibility } from "@material-ui/icons";
import { customModal, errorModal } from "../../components/modals/utils";
import { api } from "../../services";
import { useLocation, useParams } from "react-router-dom";
import ReservationForm from "./components/ReservationForm";
import GuestForm from "./components/GuestForm";
import { StylesForm } from "./styles";
import { StorageContext } from "../../contexts/StorageContext";

function Home() {
  const location = useLocation();
  const { loading, call } = hooks.useRequest();
  const [isMounted, setMount] = React.useState<any>(false);
  const [type, setType] = React.useState<any>(null);
  const [data, setData] = React.useState<any>(null);
  const [success, setSuccess] = React.useState<any>(false);
  const { dataAp, setDataAp } = useContext<any>(StorageContext);

  const Mount = React.useCallback(() => {
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.get("id") && queryParams.get("renterId")) {
      call(
        "reservation",
        api.getReservation({
          reservationId: queryParams.get("id"),
          renterId: queryParams.get("renterId"),
        }),
        async (response) => {
          if (response.ok) {
            let imgPrimary: any = null;

            let secondaryGuests: any = [...response.data?.secondaryGuests];
            let mainGuest: any = null;
            if (response.data?.primaryGuest?.imageId) {
              await call(
                null,
                api.getImage(response.data?.primaryGuest?.imageId),
                async (rImage) => {
                  if (rImage.ok) {
                    imgPrimary = rImage.data;
                  }
                }
              );
            }

            if (
              response?.data?.primaryGuest?.id === queryParams.get("renterId")
            ) {
              for (const item of secondaryGuests) {
                if (item.imageId) {
                  await call(
                    null,
                    api.getImage(item.imageId),
                    async (rImage) => {
                      if (rImage.ok) {
                        item.image = rImage.data;
                      }
                    }
                  );
                }
              }
            } else {
              for (const item of secondaryGuests) {
                if (item.id === queryParams.get("renterId")) {
                  if (item.imageId) {
                    await call(
                      null,
                      api.getImage(item.imageId),
                      async (rImage) => {
                        if (rImage.ok) {
                          secondaryGuests = { ...item, image: rImage.data };
                        } else {
                          secondaryGuests = { ...item, image: null };
                        }
                      }
                    );
                  } else {
                    secondaryGuests = item;
                  }
                }
              }
            }

            setData({
              ...response.data,
              primaryGuest: {
                ...response.data.primaryGuest,
                image: imgPrimary,
              },
              secondaryGuests: secondaryGuests,
              renterId: queryParams.get("renterId"),
            });

            setDataAp({
              ...response.data,
              primaryGuest: {
                ...response.data.primaryGuest,
                image: imgPrimary,
              },
              secondaryGuests: secondaryGuests,
              renterId: queryParams.get("renterId"),
            });
          }
        }
      );
    }
  }, []);

  React.useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  function removerBase64EAntes(texto) {
    if (!texto) return null;

    const indiceBase64 = texto.indexOf("base64,");

    if (indiceBase64 !== -1) {
      return texto.substring(indiceBase64 + 7);
    }

    return texto;
  }

  const onSubmit = (formData) => {
    const submitCallback = () => {
      errorModal.close();
      if (data.renterId === data?.primaryGuest?.id) {
        let submitData = [
          {
            id: data.primaryGuest.id,
            name: formData.fullName,
            cpf: formData.cpf,
            birthDate: formData.birthday
              ? masks.dataParaString(formData.birthday)
              : null,
            email: formData.email,
            phone: formData.phone,
            image: removerBase64EAntes(formData.file.current.base),
          },
        ];

        for (let index = 0; index < data.secondaryGuests.length; index++) {
          if (formData["fullName" + index]) {
            const guestData = {
              id: data.secondaryGuests[index].id,
              name: formData["fullName" + index],
              cpf: formData["cpf" + index],
              birthDate: formData["birthday" + index]
                ? masks.dataParaString(formData["birthday" + index])
                : null,
              email: formData["email" + index],
              phone: formData["phone" + index],
              image: removerBase64EAntes(
                formData.file.current["other-" + index]
              ),
            };
            submitData.push(guestData);
          }
        }

        call(null, api.renderAll(submitData), (response) => {
          if (response.ok) {
            setSuccess(true);
          }
        });
      } else {
        const guestData = {
          id: data.renterId,
          name: formData.fullName,
          cpf: formData.cpf,
          birthDate: formData.birthday
            ? masks.dataParaString(formData.birthday)
            : null,
          email: formData.email,
          phone: formData.phone,
          image: removerBase64EAntes(formData.current.base),
        };

        call(null, api.renderGuest(guestData), (response) => {
          if (response.ok) {
            setSuccess(true);
          }
        });
      }
    };

    alerts.setErrorModal(
      "Confirmação de Dados de Acesso",
      [
        "Ao continuar, você confirma os seus dados de acesso como usuário locatário e dados dos hóspedes acompanhantes. Deseja continuar?",
      ],
      HomeWork,
      [
        {
          label: "Sim, Confirmar",
          onClick: submitCallback,
        },
        {
          label: "Voltar",
          onClick: () => {
            errorModal.close();
          },
        },
      ]
    );
  };

  return (
    <>
      {loading ? (
        <StylesForm.ContainerExtra>
          <CircularProgress />
        </StylesForm.ContainerExtra>
      ) : success ? (
        <StylesForm.ContainerExtra>
          <CustomText fontSize={3}>Dados enviados com sucesso! 😊</CustomText>
        </StylesForm.ContainerExtra>
      ) : data ? (
        data.renterId === data?.primaryGuest?.id ? (
          <ReservationForm onSubmit={onSubmit} data={data} />
        ) : (
          <GuestForm onSubmit={onSubmit} data={data} />
        )
      ) : (
        <StylesForm.ContainerExtra>
          <CustomText>Sem Dados</CustomText>
        </StylesForm.ContainerExtra>
      )}
    </>
  );
}

export default Home;
